import { Component, Inject } from '@angular/core';
import { CoreLibModalComponent } from '../modal/modal.component';
import { DialogRef } from '../modal/dialog-ref';
import { DIALOG_DATA } from '../modal/dialog-tokens';
import { ModalService } from '../modal/modal.service';
import { AlertService } from 'app/core-lib/services/alerts/alert.service';
import { InvoiceService } from 'app/new-fs/invoice/services/invoice.service';
import { UtilService } from 'app/shared/util.service';
import { finalize } from 'rxjs/operators';

type DoubtCollectionModalData = {
  type?: {
    alert_property_type?: {
      name?: string;
    };
    translate?: Array<{
      alert_id: number;
    }>;
  };
  user?: {
    name: string;
    admin?: boolean;
    superAdmin?: boolean;
  };
  navigateInvoice: () => void;
};

@Component({
  selector: 'mh-core-lib-doubt-collection-modal',
  templateUrl: './doubt-collection-modal.component.html',
  styleUrls: ['./doubt-collection-modal.component.scss'],
  standalone: false,
})
export class CoreLibDoubtCollectionModalComponent extends CoreLibModalComponent {
  public submittingPaymentSubscription = false;

  constructor(
    protected dialogRef: DialogRef,
    @Inject(DIALOG_DATA) public data: DoubtCollectionModalData,
    private modalService: ModalService,
    private alertService: AlertService,
    private utilService: UtilService,
    private invoiceService: InvoiceService,
  ) {
    super(dialogRef, data);
  }

  handleClose() {
    if (this.data?.type?.alert_property_type?.name !== 'blocking') this.dialogRef.close();
  }

  handleSubscribeAutomaticPayment() {
    if (this.submittingPaymentSubscription) return;
    this.submittingPaymentSubscription = true;

    this.invoiceService
      .registerCallToAction(this.utilService.currentHotel.id, 1)
      .pipe(
        finalize(() => {
          this.submittingPaymentSubscription = false;
        }),
      )
      .subscribe({
        next: () => {
          this.alertService.handleAlert(
            'notifications.payment_warning.request_received',
            5000,
            'bottom',
            'end',
            'snackbar-panel-success-user-config',
          );
          this.close();
        },
        error: () => {
          this.alertService.handleAlert(
            'notifications.payment_warning.request_failed',
            5000,
            'bottom',
            'end',
            'snackbar-panel-error-user-config',
          );
        },
      });
  }

  handleInvoiceRedirect() {
    this.navigateInvoice();
    this.modalService.closeAll();
  }

  navigateInvoice() {
    return this.data.navigateInvoice();
  }

  get name() {
    return this.data.user.name;
  }

  get isAdmin() {
    return this.data.user.admin || this.data.user.superAdmin;
  }

  get isWarning() {
    const WARNING_ID = 4;
    return this.data.type.translate[0].alert_id === WARNING_ID;
  }

  get isSuspension() {
    const SUSPENSION_ID = 5;
    return this.data.type.translate[0].alert_id === SUSPENSION_ID;
  }
}
